// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
// The SQL operators that can be used for filtering.
export var Operator_Enum;
(function (Operator_Enum) {
    Operator_Enum["LIKE"] = "LIKE";
    Operator_Enum["EQUAL"] = "EQUAL";
    Operator_Enum["LT"] = "LT";
    Operator_Enum["GT"] = "GT";
    Operator_Enum["LTE"] = "LTE";
    Operator_Enum["GTE"] = "GTE";
    Operator_Enum["NOT_EQUAL"] = "NOT_EQUAL";
    Operator_Enum["NOT_LIKE"] = "NOT_LIKE";
    Operator_Enum["DATE_INTERVAL"] = "DATE_INTERVAL";
    Operator_Enum["IS_NULL"] = "IS_NULL";
    Operator_Enum["NOT_NULL"] = "NOT_NULL";
    Operator_Enum["IN"] = "IN";
    Operator_Enum["NOT_IN"] = "NOT_IN";
    Operator_Enum["IN_OR_NULL"] = "IN_OR_NULL";
})(Operator_Enum || (Operator_Enum = {}));
export var Operator_Enum_index;
(function (Operator_Enum_index) {
    Operator_Enum_index[Operator_Enum_index["LIKE"] = 0] = "LIKE";
    Operator_Enum_index[Operator_Enum_index["EQUAL"] = 1] = "EQUAL";
    Operator_Enum_index[Operator_Enum_index["LT"] = 2] = "LT";
    Operator_Enum_index[Operator_Enum_index["GT"] = 3] = "GT";
    Operator_Enum_index[Operator_Enum_index["LTE"] = 4] = "LTE";
    Operator_Enum_index[Operator_Enum_index["GTE"] = 5] = "GTE";
    Operator_Enum_index[Operator_Enum_index["NOT_EQUAL"] = 6] = "NOT_EQUAL";
    Operator_Enum_index[Operator_Enum_index["NOT_LIKE"] = 7] = "NOT_LIKE";
    Operator_Enum_index[Operator_Enum_index["DATE_INTERVAL"] = 8] = "DATE_INTERVAL";
    Operator_Enum_index[Operator_Enum_index["IS_NULL"] = 9] = "IS_NULL";
    Operator_Enum_index[Operator_Enum_index["NOT_NULL"] = 10] = "NOT_NULL";
    Operator_Enum_index[Operator_Enum_index["IN"] = 11] = "IN";
    Operator_Enum_index[Operator_Enum_index["NOT_IN"] = 12] = "NOT_IN";
    Operator_Enum_index[Operator_Enum_index["IN_OR_NULL"] = 13] = "IN_OR_NULL";
})(Operator_Enum_index || (Operator_Enum_index = {}));
// The SQL sort directions that can be used for sorting.
export var Direction_Enum;
(function (Direction_Enum) {
    Direction_Enum["ASC"] = "ASC";
    Direction_Enum["DESC"] = "DESC";
})(Direction_Enum || (Direction_Enum = {}));
export var Direction_Enum_index;
(function (Direction_Enum_index) {
    Direction_Enum_index[Direction_Enum_index["ASC"] = 0] = "ASC";
    Direction_Enum_index[Direction_Enum_index["DESC"] = 1] = "DESC";
})(Direction_Enum_index || (Direction_Enum_index = {}));
// The fields in the Appointment record that can be used for filtering and sorting.
export var Field_Enum;
(function (Field_Enum) {
    Field_Enum["APPOINTMENT_ID"] = "APPOINTMENT_ID";
    Field_Enum["EXTERNAL_ID"] = "EXTERNAL_ID";
    Field_Enum["PERSON_ID"] = "PERSON_ID";
    Field_Enum["EXTERNAL_PERSON_ID"] = "EXTERNAL_PERSON_ID";
    Field_Enum["SERVICEABLE_ID"] = "SERVICEABLE_ID";
    Field_Enum["SOURCE_ID"] = "SOURCE_ID";
    Field_Enum["SOURCE_TENANT_ID"] = "SOURCE_TENANT_ID";
    Field_Enum["SITE_ID"] = "SITE_ID";
    Field_Enum["CLIENT_LOCATION_ID"] = "CLIENT_LOCATION_ID";
    Field_Enum["APPOINTMENT_AT"] = "APPOINTMENT_AT";
    Field_Enum["CREATED_AT"] = "CREATED_AT";
    Field_Enum["MODIFIED_AT"] = "MODIFIED_AT";
    Field_Enum["CANCELED_AT"] = "CANCELED_AT";
    Field_Enum["ENTERED_AT"] = "ENTERED_AT";
    Field_Enum["LEGACY_STATUS"] = "LEGACY_STATUS";
    Field_Enum["PMS_STATUS"] = "PMS_STATUS";
    Field_Enum["PMS_TYPE"] = "PMS_TYPE";
    Field_Enum["PRACTITIONER"] = "PRACTITIONER";
    Field_Enum["OPERATORY"] = "OPERATORY";
    Field_Enum["AMOUNT"] = "AMOUNT";
    Field_Enum["LENGTH"] = "LENGTH";
})(Field_Enum || (Field_Enum = {}));
export var Field_Enum_index;
(function (Field_Enum_index) {
    Field_Enum_index[Field_Enum_index["APPOINTMENT_ID"] = 0] = "APPOINTMENT_ID";
    Field_Enum_index[Field_Enum_index["EXTERNAL_ID"] = 1] = "EXTERNAL_ID";
    Field_Enum_index[Field_Enum_index["PERSON_ID"] = 2] = "PERSON_ID";
    Field_Enum_index[Field_Enum_index["EXTERNAL_PERSON_ID"] = 3] = "EXTERNAL_PERSON_ID";
    Field_Enum_index[Field_Enum_index["SERVICEABLE_ID"] = 4] = "SERVICEABLE_ID";
    Field_Enum_index[Field_Enum_index["SOURCE_ID"] = 6] = "SOURCE_ID";
    Field_Enum_index[Field_Enum_index["SOURCE_TENANT_ID"] = 7] = "SOURCE_TENANT_ID";
    Field_Enum_index[Field_Enum_index["SITE_ID"] = 8] = "SITE_ID";
    Field_Enum_index[Field_Enum_index["CLIENT_LOCATION_ID"] = 9] = "CLIENT_LOCATION_ID";
    Field_Enum_index[Field_Enum_index["APPOINTMENT_AT"] = 10] = "APPOINTMENT_AT";
    Field_Enum_index[Field_Enum_index["CREATED_AT"] = 11] = "CREATED_AT";
    Field_Enum_index[Field_Enum_index["MODIFIED_AT"] = 12] = "MODIFIED_AT";
    Field_Enum_index[Field_Enum_index["CANCELED_AT"] = 13] = "CANCELED_AT";
    Field_Enum_index[Field_Enum_index["ENTERED_AT"] = 14] = "ENTERED_AT";
    Field_Enum_index[Field_Enum_index["LEGACY_STATUS"] = 16] = "LEGACY_STATUS";
    Field_Enum_index[Field_Enum_index["PMS_STATUS"] = 17] = "PMS_STATUS";
    Field_Enum_index[Field_Enum_index["PMS_TYPE"] = 18] = "PMS_TYPE";
    Field_Enum_index[Field_Enum_index["PRACTITIONER"] = 19] = "PRACTITIONER";
    Field_Enum_index[Field_Enum_index["OPERATORY"] = 20] = "OPERATORY";
    Field_Enum_index[Field_Enum_index["AMOUNT"] = 21] = "AMOUNT";
    Field_Enum_index[Field_Enum_index["LENGTH"] = 22] = "LENGTH";
})(Field_Enum_index || (Field_Enum_index = {}));
export const AppointmentsService = {
    // GetAppointment returns a single appointment by its ID
    GetAppointment(fn, req) {
        return fn(`/appointments/v3/appointment?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListAppointments returns a list of appointments for a location. The list can be filtered, and ordered.
    ListAppointments(fn, req) {
        return fn(`/appointments/v3/list`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // PageAppointments returns a page of appointments for a location. The list can be filtered, ordered and (of course) paged.
    PageAppointments(fn, req) {
        return fn(`/appointments/v3/page`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // CountAppointments returns the count of appointments for a location. The count can be filtered.
    CountAppointments(fn, req) {
        return fn(`/appointments/v3/count`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
